export default __webpack_public_path__ + "static/media/logo.60fd613c.jpeg";